export enum FuelMeasurementType {
    Measured = 'Measured',
    FuelFraction = 'FuelFraction',
    Value = 'Value',
    OwnFuelSupply = 'OwnFuelSupply'
}
